import Vue from "vue";
import Router from "vue-router";

const Login = () =>
  import(/* webpackChunkName: "views-Login.route" */ `./views/Login.vue`);
const SignUp = () =>
  import(/* webpackChunkName: "views-SignUp.route" */ `./views/SignUp.vue`);
const Home = () =>
  import(/* webpackChunkName: "views-Home.route" */ `./views/Home.vue`);
const Customers = () =>
  import(
    /* webpackChunkName: "views-Customers.route" */ `./views/Customers.vue`
  );
const Messages = () =>
  import(/* webpackChunkName: "views-Messages.route" */ `./views/Messages.vue`);
const Calls = () =>
  import(/* webpackChunkName: "views-Calls.route" */ `./views/Calls.vue`);
const Settings = () =>
  import(/* webpackChunkName: "views-Settings.route" */ `./views/Settings.vue`);
const Reports = () =>
  import(/* webpackChunkName: "views-Reports.route" */ `./views/Reports.vue`);
const Reviews = () =>
  import(/* webpackChunkName: "views-Reports.route" */ `./views/Reviews.vue`);
const Tracking = () =>
  import(/* webpackChunkName: "views-Tracking.route" */ `./views/Tracking.vue`);
const UserNotAuthorized = () =>
  import(
    /* webpackChunkName: "components-errors-UserNotAuthorized.route" */ `./components/errors/UserNotAuthorized.vue`
  );

Vue.use(Router);

const routes = [
  {
    path: "/login/",
    name: "login",
    component: Login,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: "/sign-up/",
    name: "signup",
    component: SignUp,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: "/customers/",
    name: "customers",
    component: Customers,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: "/messages/",
    name: "messages",
    component: Messages,
    pathToRegexpOptions: { strict: true }
  },
  // {
  //   path: "/chats/",
  //   name: "chats",
  //   component: Chats,
    // pathToRegexpOptions: { strict: true }
  // },
  {
    path: "/calls/",
    name: "calls",
    component: Calls,
    pathToRegexpOptions: { strict: true }
  },
  // {
  //   path: "/inbox/",
  //   name: "inbox",
  //   component: Inbox
  // },
  {
    path: "/reviews/",
    name: "reviews",
    component: Reviews
  },
  // {
  //   path: "/calendar/",
  //   name: "calendar",
  //   ref: "calendar",
  //   component: Calendar
  // },
  {
    path: "/settings/",
    name: "settings",
    component: Settings,
    pathToRegexpOptions: { strict: true }
  },
  // {
  //   path: "/settings/:section/",
  //   name: "settings-:section",
  //   component: Settings
  // },
  {
    path: "/tracking/",
    name: "tracking",
    component: Tracking,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: "/reports/",
    name: "reports",
    component: Reports,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: "/error/not-authorized/",
    name: "error-not-authorized",
    component: UserNotAuthorized,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: "/",
    name: "home",
    component: Home,
    pathToRegexpOptions: { strict: true }
  }
  // },
  // {
  //   path: "*",
  //   name: "404",
  //   component: 404
  // }
];

const router = new Router({
  mode: "history",
  routes: routes
});

/*
router.beforeEach((to, from, next) => {
  if (
    to.path === "/" //||
    //to.path === "/auth/callback/" ||
    //auth.isAuthenticated()
  ) {
    return next();
  } else {
    // Specify the current path as the customState parameter, meaning it
    // will be returned to the application after auth
    //auth.login({ target: to.path });
    return next();
  }
});*/

export default router;
